// src/components/Separated.tsx
import { isLastIndex } from "@teamsparta/utils";
import {
  Children,
  Fragment,
  isValidElement
} from "react";
import { Fragment as Fragment2, jsxs } from "react/jsx-runtime";
function Separated({
  children,
  with: separator,
  first = false,
  last = false
}) {
  const childrenArray = Children.toArray(children);
  return /* @__PURE__ */ jsxs(Fragment2, { children: [
    first && separator,
    childrenArray.map((child, index) => /* @__PURE__ */ jsxs(Fragment, { children: [
      child,
      !isLastIndex(index, childrenArray) && separator
    ] }, isValidElement(child) ? child.key ?? index : index)),
    last && separator
  ] });
}

export {
  Separated
};
